module.exports = __webpack_public_path__ + "img/limit.0395a2ea.png";